import { render, staticRenderFns } from "./AnswerPopup.vue?vue&type=template&id=834c8c7e"
import script from "./AnswerPopup.vue?vue&type=script&lang=js"
export * from "./AnswerPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports